<template>
  <div>
    <b-row>
      <b-col md="3">
        <h6 class="font-sm font-family-regular ml-5 mb-0">
          {{ item }}
        </h6>
      </b-col>
      <b-col md="9" class="d-flex flex-row align-items-center">
        <b-col
          class="d-flex justify-content-center align-items-center p-0"
          :class="
            projection.value > 90
              ? 'greenBackground'
              : projection.value <= 90 && projection.value >= 65
              ? 'redBackground'
              : 'yellowBackground'
          "
          md="1"
          v-for="(projection, index) in projection"
          :key="index"
        >
          <!-- <h6 class="font-sm mb-0">{{ projection.value }}</h6> -->
          <b-form-input
            v-model="projection.value"
            @keypress.enter="save(index)"
            class="capacity-input"
          ></b-form-input>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CapacityCards",
  props: ["item", "projection", "update", "assistantIndex", "customerIndex"],
  computed: {
    ...mapState("authModule", ["profileUserId"])
  },
  methods: {
    save(index) {
      if (
        typeof parseInt(this.projection[index].value) === "number" &&
        parseInt(this.projection[index].value) < 800 &&
        parseInt(this.projection[index].value) > 0
      ) {
        this.$emit("update", index, this.assistantIndex, this.customerIndex);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.redBackground {
  background: #f4cccc;
}
.greenBackground {
  background: #b7e1cd;
}
.yellowBackground {
  background: #fff2cc;
}
.capacity-input {
  text-align: center;
}
</style>
